import type { WorldTheme } from './theme';

/**
 * United States sky of world 3: El Paso (GDD §11.1, §14.2, issue #123). Desert orange at dusk: a dark sienna sky, flat
 * mesas in desert orange and a highway with blank road signs in the distance (no text and no brand: §3.4). It is
 * activated at the border crossing (`border:crossed`, as Miami #97 and New York #112). The sky stays dark so that the
 * bills keep 3:1 against it and every pickup stays more saturated than the decoration (GDD §14.1).
 */

const EL_PASO = {
  mesa: 0x9a6c52,
  mesaSoft: 0xa87a5e,
  block: 0x7a5440,
  blockDark: 0x684636,
  foreground: 0x3a2a24,
  signPost: 0x7a7a7a,
  signBoard: 0x2f6a4a,
} as const;

export const USA_EL_PASO: WorldTheme = {
  id: 'usa-el-paso',
  variant: 'el-paso',
  sky: 0x5a3326,
  fog: { color: 0x6a4030, near: 40, far: 150 },
  ground: 0x7a4a2a,
  ceiling: 0xe6b88a,
  collidable: { column: 0x33d060, pickup: 0xe0a000 },
  lights: {
    hemisphere: { sky: 0xffd0a0, ground: 0x4a3024, intensity: 0.95 },
    sun: { color: 0xff9a5a, intensity: 1.9, position: [-8, 8, 12] },
  },
  layers: [
    { name: 'layer.far', colors: [EL_PASO.mesa, EL_PASO.mesaSoft], moduleWidth: 26, height: 9, baseY: 1, motif: 'buildings' },
    { name: 'layer.mid', colors: [EL_PASO.block, EL_PASO.blockDark], moduleWidth: 16, height: 4, baseY: 1, motif: 'buildings' },
    { name: 'layer.foreground', colors: [EL_PASO.foreground], moduleWidth: 10, height: 1.4, baseY: -0.6, motif: 'foreground', followCamera: true },
  ],
  signs: { post: EL_PASO.signPost, board: EL_PASO.signBoard },
};
